/**
 * Short factual line-items shown under the hero. Every item here must be
 * literally true for a pre-launch B2B studio — no traction claims, no
 * jurisdictional claims, no licences we don't hold. Concrete signals
 * beat restated pricing.
 */
export const TRUST_STRIP: string[] = [
  "Engine MIT-licensed",
  "Seeds reproducible in browser",
  "10k-round RTP test in repo",
  "USDT/USDC weekly settlement",
];
